import { useQueryClient } from "@tanstack/react-query"
import { prospectsKeys } from "@apis/prospects/queryKeys"

export const useUtils = () => {
  const queryClient = useQueryClient()

  const handleSaveAddress = (
    prospect_guid: string,
    closeDrawer: () => void,
  ) => {
    queryClient.invalidateQueries({
      queryKey: prospectsKeys.detail(prospect_guid),
    })
    closeDrawer()
  }

  return { handleSaveAddress }
}

type TUrlParams = Record<string, string | undefined>

export type TStepResolution =
  | { step: "chooseOffer"; shopper_guid?: string }
  | { step: "signUp" }
  | { step: "confirmation"; order_id: number }

export const defineStep = (urlParams: TUrlParams): TStepResolution => {
  const { shopper_guid, order_id } = urlParams

  if (shopper_guid) {
    return { step: "chooseOffer", shopper_guid }
  }

  if (order_id) {
    const id = Number(order_id)
    if (!Number.isNaN(id)) return { step: "confirmation", order_id: id }
  }

  return { step: "chooseOffer" }
}

export type TEntrySource = "newOrder" | "shopper" | "order"

// Derived from the URL instead of marked at each link: `shopper_guid` is what makes
// the funnel load an existing shopper, so a continuation entry point cannot omit it.
// This holds as long as the funnel never writes `shopper_guid` into the URL itself.
export const getEntrySource = (urlParams: TUrlParams): TEntrySource => {
  const { shopper_guid, order_id } = urlParams
  if (shopper_guid) return "shopper"
  if (order_id && !Number.isNaN(Number(order_id))) return "order"
  return "newOrder"
}
